import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import zhCN from "./zh-CN";
import en from "./en";
import { Locale } from "./locales";

i18n.use(initReactI18next).init({
  fallbackLng: Locale.zhCN,
  debug: true,
  resources: {
    zhCN: zhCN,
    en: en,
  },
  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
  },
});

export default i18n;
